import React, {Component} from 'react';
import {Icon, Button} from 'semantic-ui-react';

export class BackButton extends Component {
  onClick;

  render() {
    return (
      <Button animated onClick={this.props.onClick}>
        <Button.Content visible>Back</Button.Content>
        <Button.Content hidden>
          <Icon name='arrow left' />
        </Button.Content>
      </Button>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/BackButton/BackButton.js